import { Colors } from '@Constants';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { P3 } from '../../components/GlobalStyles';
import { font, media } from '../style-utils';
import styles from './TestimonialGrid.module.css';

export default class TestimonialGrid extends Component {
  static propTypes = {
    breakPoints: PropTypes.arrayOf(PropTypes.number),
  };
  static defaultProps = {
    breakPoints: [900],
  };

  render() {
    const { items } = this.props;

    return (
      <div className={styles.masonry_container}>
        <Masonry breakPoints={this.props.breakPoints}>
          {items.map((item, id) => {
            if (item.type === 'image') {
              return <ImgTile key={id} src={item.src} />;
            }
            return (
              <Tile
                key={id}
                text={item.text}
                sourceName={item.sourceName}
                sourceTitle={item.sourceTitle}
                sourceImage={item.sourceImage}
              />
            );
          })}
        </Masonry>
      </div>
    );
  }
}

const Testimonial = styled.div`
  background: #ffffff;
  /* box-shadow: 0 0.6rem 1.4rem 0 rgba(113, 112, 114, 0.2); */
  box-shadow: 0 0.2rem 0.8rem 0 rgba(0, 0, 0, 0.18);
  /* border-radius: 1.4rem; */
  z-index: 0;
  position: relative;

  & + & {
    margin-top: 2.5rem;
  }

  ${media.tabletLandscapeAndUp`
    margin: 0 auto;
    padding: 7rem 6.5rem 4rem;
  `};

  ${font(16, 'Book', 21, -0.5)};
  color: #000000;
  text-align: left;

  ${media.desktopAndUp`
    font-size: 2rem;
  `};
`;
const TestimonialText = styled(P3)`
  position: relative;
  padding-left: 4rem;
`;
const TestimonialSource = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: left;
  margin-top: 1.5em;

  > div {
    flex: 0 0 auto;
  }
`;
const TestimonialSourceImage = styled.div`
  border: 0.3rem solid ${Colors.Primary};
  border-radius: 100%;
  width: 7.5rem;
  height: 7.5rem;
  overflow: hidden;
  margin-right: 0.75em;
  position: relative;

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;
const TestimonialSourceName = styled.div`
  ${font(12, 'Black', 12, 2)};
  color: #000000;
  text-transform: uppercase;

  ${media.desktopAndUp`
    font-size: 1.4rem;
  `};
`;
const TestimonialSourceTitle = styled.div`
  ${font(12, 'Book', 12, -0.5)};
  color: ${Colors.PrimaryDark};
  margin-top: 0.2em;

  ${media.desktopAndUp`
    font-size: 1.4rem;
  `};
`;
const TestimonialImage = styled.img`
  width: 100%;
  display: block;
`;

const ImgTile = props => {
  return (
    <Testimonial style={{ padding: '2rem' }} className={styles.masonry_tile}>
      <TestimonialImage src={props.src} alt={props.sourceName} />
    </Testimonial>
  );
};

const QuoteIcon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  font-size: 15rem;
  color: ${Colors.PrimaryLight2};
  transform: translate(-2.5rem, 3rem);
  z-index: -1;
`;

const Tile = props => {
  return (
    <Testimonial
      style={{ padding: '2.4em 2em 1.4em' }}
      className={styles.masonry_tile}
    >
      <TestimonialText as="div">
        <QuoteIcon>“</QuoteIcon>
        {props.text}
      </TestimonialText>
      <TestimonialSource>
        {props.sourceImage && (
          <TestimonialSourceImage>
            <img src={props.sourceImage} alt={props.sourceName} />
          </TestimonialSourceImage>
        )}
        <div>
          <TestimonialSourceName>{props.sourceName}</TestimonialSourceName>
          <TestimonialSourceTitle
            dangerouslySetInnerHTML={{ __html: props.sourceTitle }}
          />
        </div>
      </TestimonialSource>
    </Testimonial>
  );
};

class Masonry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { columns: 1 };

    this.refMasonry = React.createRef();
  }

  componentDidMount() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize, false);
  }

  getColumns = w => {
    let count = 1;
    for (let breakpoint of this.props.breakPoints) {
      if (w < breakpoint) {
        break;
      }
      count++;
    }
    return count;
  };

  onResize = () => {
    const columns = this.getColumns(this.refMasonry.current.offsetWidth);
    if (columns !== this.state.columns) {
      this.setState({ columns: columns });
    }
  };

  mapChildren = () => {
    let col = [];
    const numC = this.state.columns;
    for (let i = 0; i < numC; i++) {
      col.push([]);
    }
    return this.props.children.reduce((p, c, i) => {
      p[i % numC].push(c);
      return p;
    }, col);
  };

  render() {
    return (
      <div className={styles.masonry} ref={this.refMasonry}>
        {this.mapChildren().map((col, ci) => {
          return (
            <div className={styles.masonry_column} key={ci}>
              {col.map((child, i) => {
                return (
                  <div className={styles.masonry_item} key={i}>
                    {child}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TestimonialGrid/TestimonialGrid.js